import { useState } from "react";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { frApi, errMsg, cardCls, labelCls, btnPrimary, MONTHLY_RULE_LABEL } from "./frUtils";

const DURATION_RULES = { proportional: "Scale with session length (e.g. 90 min = 1.5 × the 60-min rate)", fixed: "Same fee per session whatever the length" };

const Radio = ({ name, value, current, label, onChange }) => (
    <label className="flex items-start gap-2.5 p-3 rounded-xl border border-slate-200 has-[:checked]:border-[#1E3A8A] has-[:checked]:bg-blue-50 cursor-pointer">
        <input type="radio" name={name} value={value} checked={current === value} onChange={() => onChange(value)} className="mt-0.5 w-4 h-4" data-testid={`fr-rule-${name}-${value}`} />
        <span className="text-sm">{label}</span>
    </label>
);

export default function SettingsTab({ settings, onSaved }) {
    const [s, setS] = useState(settings);
    const [busy, setBusy] = useState(false);
    const save = async () => {
        setBusy(true);
        try { await frApi.put("/settings", { ...s, bundle_included: s.bundle_included || 2, bundle_max: s.bundle_max || 3 }); toast.success("Calculation rules saved"); onSaved(); } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
    };
    return (
        <div className={`${cardCls} space-y-5 max-w-2xl`} data-testid="fr-settings">
            <div className="space-y-2">
                <div className={labelCls}>Monthly session count</div>
                {Object.entries(MONTHLY_RULE_LABEL).map(([v, l]) => <Radio key={v} name="monthly" value={v} current={s.monthly_rule} label={l} onChange={(x) => setS({ ...s, monthly_rule: x })} />)}
            </div>
            <div className="space-y-2">
                <div className={labelCls}>Session length vs fee</div>
                {Object.entries(DURATION_RULES).map(([v, l]) => <Radio key={v} name="duration" value={v} current={s.duration_rule} label={l} onChange={(x) => setS({ ...s, duration_rule: x })} />)}
            </div>
            <div className="space-y-2">
                <div className={labelCls}>Classes 9–10 subject bundle (one common teacher)</div>
                <div className="grid grid-cols-3 gap-3">
                    {[["bundle_included", "Subjects covered"], ["bundle_max", "Maximum subjects"], ["extra_subject_fee", "Extra subject ₹/month"]].map(([k, l]) => (
                        <div key={k}><label className="block text-[11px] text-slate-500 mb-1">{l}</label>
                            <input type="number" min={0} value={s[k] ?? ""} onChange={(e) => setS({ ...s, [k]: e.target.value === "" ? null : Number(e.target.value) })}
                                className="w-full h-11 px-3 text-sm border border-slate-200 rounded-lg" data-testid={`fr-rule-${k}`} /></div>
                    ))}
                </div>
            </div>
            <button type="button" onClick={save} disabled={busy} className={btnPrimary} data-testid="fr-settings-save">{busy && <Loader2 className="w-4 h-4 animate-spin" />} Save rules</button>
        </div>
    );
}
